var map = {
	"./banner.png": "6tPr",
	"./banner2.png": "/ipX",
	"./banner3.png": "KneU",
	"./banner4.png": "iEUx",
	"./banner5.png": "tsLI",
	"./btn1.png": "UTw2",
	"./btn2.png": "IH9C",
	"./cdr.png": "sHxz",
	"./close.png": "QgQU",
	"./css.png": "g8xd",
	"./djg_icon.png": "REHa",
	"./doc.png": "VDvn",
	"./doc_1.png": "V4DG",
	"./dwg.png": "mXz5",
	"./eight.png": "sXy4",
	"./error_img.png": "IUVo",
	"./file.png": "s1Qq",
	"./five.png": "IY1H",
	"./format_banner.png": "CaT9",
	"./four.png": "cKOG",
	"./html.png": "ALTC",
	"./icon1.png": "y/u3",
	"./icon2.png": "eJcP",
	"./img.png": "DPDN",
	"./img_1.png": "rI5s",
	"./night.png": "8z05",
	"./one.png": "NQQ/",
	"./open.png": "e7de",
	"./pdf.png": "/fl+",
	"./pdf_1.png": "3N0j",
	"./ppt.png": "pzQM",
	"./ppt_1.png": "ry8p",
	"./psd.png": "P7Lw",
	"./qz_banner.png": "b0Nv",
	"./seven.png": "Oygd",
	"./six.png": "plNl",
	"./ten.png": "yE1e",
	"./three.png": "cAIk",
	"./tiff.png": "YHun",
	"./tiff_1.png": "f2d4",
	"./two.png": "F2jD",
	"./txt.png": "g2t7",
	"./txt_1.png": "3QYA",
	"./word.png": "fNyy",
	"./word_1.png": "mWcO",
	"./wps.png": "KLtf",
	"./wps_1.png": "xYSX",
	"./xlx.png": "yXku",
	"./xlx_1.png": "FQL9",
	"./yq_icon.png": "ZxVE",
	"./yq_icon_active.png": "xG3T",
	"./zip.png": "6T+P",
	"./zip_1.png": "ScvJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PW4V";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview ^\.\/.*$
// module id = PW4V
// module chunks = 2